import React from 'react';
import CameraItem from '../CameraItem';
import ArrowLeftCircle from '../../../assets/icons/arrow-left-circle.svg';
import ArrowRightCircle from '../../../assets/icons/arrow-right-circle.svg';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { useSelector } from 'react-redux';

const CameraSlider = ({
  data,
  isSeeking,
  getAppearanceTimeStyle,
  playerRefs,
  handleProgress,
  setSelectedStream,
  selectedStream,
  totalPage,
  pagination,
  setPagination,
}) => {
  const { generateLinkStorageFileByTime } = useSelector(state => state);

  const onNextVideo = () => {
    setPagination(state => {
      if (state.page < totalPage) {
        return { ...state, page: state.page + 1 };
      }
      return state;
    });
  };

  const onPrevVideo = () => {
    setPagination(state => {
      if (state.page > 1) {
        return { ...state, page: state.page - 1 };
      }
      return state;
    });
  };

  const NextArrow = props => {
    return (
      <div
        style={{
          display: totalPage > pagination.page ? 'block' : 'none',
        }}
        className="next-video"
        onClick={onNextVideo}
      >
        <img src={ArrowRightCircle} width={24} height={24} />
      </div>
    );
  };

  const PrevArrow = props => {
    return (
      <div
        className="prev-video"
        onClick={onPrevVideo}
        style={{
          display: pagination.page > 1 ? 'block' : 'none',
        }}
      >
        <img src={ArrowLeftCircle} width={24} height={24} />
      </div>
    );
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: Math.min(data?.length, 5),
    slidesToScroll: 5,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(data?.length, 5),
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
    ],
  };

  return (
    <Slider {...settings}>
      {data?.map(camera => (
        <CameraItem
          key={camera.serial}
          camera={camera}
          isSelected={camera.serial === selectedStream?.serial}
          onDoubleClick={() => setSelectedStream(camera)}
          onClick={() => setSelectedStream(camera)}
          generateLinkStorageFileByTime={generateLinkStorageFileByTime}
          getAppearanceTimeStyle={getAppearanceTimeStyle}
          playerRefs={playerRefs}
          handleProgress={handleProgress}
          isSeeking={isSeeking}
        />
      ))}
    </Slider>
  );
};

export default CameraSlider;
